import { useEffect } from "react";
import { DEFAULT_FONTS, FONTS, chosenFont, fontsHref } from "@/lib/fonts";

const PREVIEW_LINK_ID = "ekko-font-previews";
const CHOICES = [
  { field: "font_title", title: "Letra dos títulos", sample: "Encontra o teu momento", sampleClass: "text-2xl font-bold", hasCaps: true },
  { field: "font_body", title: "Letra dos textos", sample: "Aulas ao longo do dia e espaço livre para treinares ao teu ritmo.", sampleClass: "text-base" },
];

// Carrega todas as letras da lista uma vez, só no painel, para se verem os exemplos
function usePreviewFonts() {
  useEffect(() => {
    if (document.getElementById(PREVIEW_LINK_ID)) return;
    const link = document.createElement("link");
    link.id = PREVIEW_LINK_ID;
    link.rel = "stylesheet";
    link.href = fontsHref(FONTS);
    document.head.appendChild(link);
  }, []);
}

// Interruptor “Títulos em maiúsculas” (título do topo e títulos das secções)
function CapsToggle({ checked, onChange }) {
  return (
    <label className="mt-4 flex items-center justify-between gap-3 cursor-pointer select-none">
      <span>
        <span className="block text-[#F5F5F5] text-sm font-semibold">Títulos em maiúsculas</span>
        <span className="block text-[#8A8A8A] text-xs">O título do topo e os títulos das secções</span>
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className={`relative w-11 h-6 shrink-0 rounded-full transition-colors ${checked ? "bg-[#A6C48A]" : "bg-[#3A3A3A]"}`}
      >
        <span className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-[#F5F5F5] transition-transform ${checked ? "translate-x-5" : ""}`} />
      </button>
    </label>
  );
}

// Separador Layout → “Letra do site”: uma escolha para todos os títulos e outra para todos os textos
export default function FontPicker({ content, setContent }) {
  usePreviewFonts();
  const isUpper = Boolean(content.titles_uppercase);
  const setUpper = (value) => setContent((prev) => ({ ...prev, titles_uppercase: value }));

  return (
    <>
      <h3 className="text-xl font-bold text-[#F5F5F5] mt-10 mb-2">Letra do site</h3>
      <p className="text-[#A1A1AA] text-sm mb-4">
        Uma letra para todos os títulos e outra para todos os textos. A da marca é Ancizar Sans nos títulos e Lato nos textos.
        Clica em <strong>Guardar</strong> (em cima) para aplicar.
      </p>
      <div className="grid md:grid-cols-2 gap-4">
        {CHOICES.map(({ field, title, sample, sampleClass, hasCaps }) => {
          const current = chosenFont(content, field);
          return (
            <div key={field} className="bg-[#1F1F1F] rounded-lg p-4 border border-[#3A3A3A]">
              <label htmlFor={`select-${field}`} className="block text-[#A6C48A] font-bold mb-2">{title}</label>
              <select
                id={`select-${field}`}
                value={current.key}
                onChange={(e) => setContent((prev) => ({ ...prev, [field]: e.target.value }))}
                className="w-full bg-[#141414] border border-[#3A3A3A] rounded px-3 py-2 text-[#F5F5F5] text-sm"
              >
                {FONTS.map((font) => (
                  <option key={font.key} value={font.key}>
                    {font.label}{font.key === DEFAULT_FONTS[field] ? " (a da marca)" : ""}
                  </option>
                ))}
              </select>
              <p
                className={`mt-3 text-[#F5F5F5] ${sampleClass}${hasCaps && isUpper ? " uppercase tracking-[0.03em]" : ""}`}
                style={{ fontFamily: `'${current.family}'` }}
              >
                {sample}
              </p>
              {hasCaps && <CapsToggle checked={isUpper} onChange={setUpper} />}
            </div>
          );
        })}
      </div>
    </>
  );
}
